import { createBrowserHistory, History } from "history";

const browserHistory: History = createBrowserHistory();

export default browserHistory;
